<template>
  <div data-component="app-launcher-settings">
    <app-launcher-versions
      :s-active="sActive"
      :s-initial="sInitial"
      :versions="versions"
      :migrations-by-range="migrationsByRange"
      :is-disabled="isDisabled"
      :is-saving="isSaving"
      @settings-change="$emit('settings-change', $event)"
      @save="$emit('save')"
    />

    <app-launcher-options
      :settings="sActive"
      :is-disabled="isDisabled"
      @settings-change="$emit('settings-change', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import AppLauncherVersions from './AppLauncherVersions.vue';
import AppLauncherOptions from './AppLauncherOptions.vue';
import {
  APP_SETTINGS_PROP,
  APP_VERSIONS_PROP,
  MIGRATIONS_BY_RANGE_PROP,
} from '../../constants';

export default defineComponent({
  name: 'AppLauncherSettings',
  components: {
    AppLauncherVersions,
    AppLauncherOptions,
  },
  props: {
    sActive: APP_SETTINGS_PROP,
    sInitial: APP_SETTINGS_PROP,
    versions: APP_VERSIONS_PROP,
    migrationsByRange: MIGRATIONS_BY_RANGE_PROP,
    isDisabled: Boolean,
    isSaving: Boolean,
  },
  emits: ['settings-change', 'save'],
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='app-launcher-settings'] {
  display: flex;
  flex-direction: column;
  gap: var(--s-5);
  width: 100%;

  @include md {
    width: 40rem;
  }
}
</style>
